<template>
	<FormulateInput
		v-if="!isHideField"
		:value="context.model"
		:label="context.attributes['label-text']"
		type="select"
		name="signup_to_club"
		:options="context.options"
		placeholder="Выберите значение"
		class=""
		validation="required"
		:validation-messages="{
			'required': 'выберите значение',
		}"
		@change="(e) => $emit('input', e)"
	/>
</template>

<script>

export default {
	props: {
		context: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			isHideField: false,
		};
	},
	async created() {
		const { data: values } = await this.$api.getUserProfileFields('slugs[]=alumni_clubs');
		const club = this.context.options.find((option) => +option.value > 0);
		if (club && values?.alumni_clubs?.includes(club.value)) {
			this.isHideField = true;
		}
	},
};
</script>
